import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import { Parameters } from '../../models';
import { BaseListingQuery } from '../common/base-listing-query.class';
export var LanguagesQuery =
/*#__PURE__*/
function (_BaseListingQuery) {
  _inherits(LanguagesQuery, _BaseListingQuery);

  function LanguagesQuery(config, queryService) {
    var _this;

    _classCallCheck(this, LanguagesQuery);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LanguagesQuery).call(this, config, queryService));
    _this.config = config;
    _this.queryService = queryService;
    /**
     * Endpoint
     */

    _this.endpoint = 'languages';
    _this._queryConfig = {};
    return _this;
  }
  /**
   * Limits the number of taxonomies returned by query
   * @param limit Number of taxonomies to load
   */


  _createClass(LanguagesQuery, [{
    key: "limitParameter",
    value: function limitParameter(limit) {
      this.parameters.push(new Parameters.LimitParameter(limit));
      return this;
    }
    /**
     * Skips the selected number of taxonomies
     * @param skip Number of taxonomies to skip
     */

  }, {
    key: "skipParameter",
    value: function skipParameter(skip) {
      this.parameters.push(new Parameters.SkipParameter(skip));
      return this;
    }
  }, {
    key: "toPromise",
    value: function toPromise() {
      var _a;

      return this.queryService.getLanguages(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var action = '/' + this.endpoint;
      return _get(_getPrototypeOf(LanguagesQuery.prototype), "resolveUrlInternal", this).call(this, action);
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */

  }, {
    key: "queryConfig",
    value: function queryConfig(_queryConfig) {
      this._queryConfig = _queryConfig;
      return this;
    }
  }, {
    key: "map",
    value: function map(json) {
      return this.queryService.mappingService.listLanguagesResponse(json);
    }
  }, {
    key: "allResponseFactory",
    value: function allResponseFactory(items, responses) {
      return {
        items: items,
        responses: responses
      };
    }
  }]);

  return LanguagesQuery;
}(BaseListingQuery);